module.exports = __webpack_public_path__ + "static/img/img_cabinet.ad12a0fe.png";